export const OTModalKey = 'ot-modal';
